import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { useSelector } from 'react-redux';
import UIFlex from 'UIComponents/layout/UIFlex';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import { useAppSelector } from '../../../reducers';
import { currentSkuIdForProductSelector, productSelector, productVersionSelector } from '../../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';

const SuiteBusinessObjectivesSubtext = ({
  productLevel,
  productLine
}) => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const product = useSelector(state => productSelector(state, {
    productLine,
    productLevel
  }));
  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productId: product.id
  }));
  const quantityPackDetails = useAppSelector(state => skuId ? productVersionSelector(state, {
    skuId
  }).quantityPackDetails : []);
  const quantityPack = quantityPackDetails[0];
  const includedSeats = 1; // TODO: update using includedUnits or packagedQuantities once MonBE has updated the products response

  const seatsSubtextTranslation = ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][productLine].seatsSubtext;
  if (!quantityPack && !seatsSubtextTranslation) return null;
  const includedWithProductVersion = quantityPack && quantityPack.quantityUnit && quantityPack.quantityUnit.includedWithProductVersion;
  const messageTranslation = ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][productLine][isSeatsRedesignUngated ? 'extraQuantityUnits' : 'subtext'];
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    children: [messageTranslation && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: messageTranslation,
      elements: {
        IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
          value: includedWithProductVersion
        })
      }
    }), isSeatsRedesignUngated && seatsSubtextTranslation && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: seatsSubtextTranslation,
      options: {
        count: includedSeats
      },
      elements: {
        IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
          value: includedSeats
        })
      }
    })]
  });
};

export default SuiteBusinessObjectivesSubtext;